import { useState, useEffect, useCallback } from "react";
import { uploadsUrl } from "../utils/api";
import "./Navbar.css";

export default function Navbar({
  projectId,
  projectName,
  authorizedChannelPartner,
  onCtaClick,
}) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  const scrollTo = useCallback((selector) => {
    setOpen(false);
    const el = document.querySelector(selector);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}`} aria-label="Main navigation">
      <div className="navbar__inner">

        {/* Logo */}
        <a className="navbar__brand" href="/" aria-label={`${projectName} home`}>
          <img
            src={uploadsUrl(projectId, "logo.webp")}   // ✅ CORRECT
            alt={`${projectName} Logo`}
            className="navbar__logo"
            width="160"
            height="45"
            loading="eager"
          />
        </a>

        {/* Mobile phone icon */}
        <a href="tel:+918069368300" className="navbar__phone-icon" aria-label="Call us">
          <img
            src="https://microsite.thehomestore.co.in/uploads/phone_animation.gif"
            alt="Call"
            width="28"
            height="28"
          />
        </a>

        {/* Hamburger */}
        <button
          className={`navbar__toggler${open ? " open" : ""}`}
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          <span /><span /><span />
        </button>

        {/* Nav links */}
        <div className={`navbar__collapse${open ? " show" : ""}`} id="navMenu">

          {authorizedChannelPartner && (
            <div className="navbar__channel-partner">
              <img
                src="https://microsite.thehomestore.co.in/uploads/homestore_logo.png"
                alt="The Homestore"
                className="navbar__logo navbar__logo--partner"
              />
              <span className="navbar__partner-label">
                Authorised Channel Partner
              </span>
            </div>
          )}

          <ul className="navbar__nav">
            <li>
              <a href="tel:+918069368300" className="navbar__link navbar__link--cta">
                📞 +91 8069368300
              </a>
            </li>

            <li><button className="navbar__link" onClick={() => scrollTo(".about-section")}>About</button></li>
            <li><button className="navbar__link" onClick={() => scrollTo(".location-section")}>Location</button></li>
            <li><button className="navbar__link" onClick={() => scrollTo(".apartment-section")}>Price</button></li>
            <li><button className="navbar__link" onClick={() => scrollTo(".gallery-section")}>Gallery</button></li>
          </ul>

        </div>
      </div>
    </nav>
  );
}